module.exports = __webpack_public_path__ + "img/home-kurs-1.32f3a4b9.png";